const PDF_MARGIN_MM = 14;
const PIXEL_RATIO = 2;

function loadImage(dataUrl: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = reject;
    img.src = dataUrl;
  });
}

/**
 * Захват DOM-элемента в PDF (landscape A4, многостраничный).
 * html-to-image нужен для поддержки OKLCH-цветов и кириллицы.
 */
export async function exportElementToPdf(
  element: HTMLElement,
  filenamePrefix: string
): Promise<void> {
  const [{ jsPDF }, { toPng }] = await Promise.all([import('jspdf'), import('html-to-image')]);

  const dataUrl = await toPng(element, {
    pixelRatio: PIXEL_RATIO,
    backgroundColor: '#ffffff',
  });

  const { width: naturalWidth, height: naturalHeight } = await loadImage(dataUrl);

  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const imgWidth = pageWidth - PDF_MARGIN_MM * 2;
  const imgHeight = (naturalHeight * imgWidth) / naturalWidth;
  const contentHeight = pageHeight - PDF_MARGIN_MM * 2;

  let yOffset = 0;
  while (yOffset < imgHeight) {
    if (yOffset > 0) doc.addPage();
    doc.addImage(dataUrl, 'PNG', PDF_MARGIN_MM, PDF_MARGIN_MM - yOffset, imgWidth, imgHeight);
    yOffset += contentHeight;
  }

  const dateStr = new Date().toISOString().split('T')[0];
  doc.save(`${filenamePrefix}-${dateStr}.pdf`);
}
